import React from "react";
import PropTypes from 'prop-types';

interface EyebrowProps extends React.HTMLAttributes<HTMLElement> {
    // Baseline arguments
    children?: React.ReactNode;
    className?: string;
}

/**
 * An eyebrow that usually goes above headers.
 * 
 * ## _
 * ### Arguments
 * @param {React.ReactNode} children - The contents inside the eyebrow. This is usually just text.
 * @param {string} className - CSS classes to apply to the eyebrow.
 */
class Eyebrow extends React.Component<EyebrowProps> {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    }

    static defaultProps = {
        className: "",
    }

    render() {
        const { children, className, ...rest } = this.props;

        return (
            <span className={`a-eyebrow ${className}`} {...rest}>
                {children}
            </span>
        );
    }
}

export default Eyebrow;